export const TRANSLATION_TEXT_SEARCH_FIELDS = ['Key', 'Translated Text', 'Portal Page Name'] as const;

export type TranslationTextSearchOption = (typeof TRANSLATION_TEXT_SEARCH_FIELDS)[number];
